// The house slide-up modals (.modal-backdrop + .modal-slide-up) animate IN
// but used to vanish on close. dismissModal plays the exit - the same fade
// and 40px drop the admin pages dismiss with - and runs the real close
// (usually the state-clearing onClose prop) when the animation ends.
//
// Use it anywhere a house modal closes: X buttons, backdrop clicks, Cancel
// buttons, and programmatic closes after a save. It finds the modal's own
// backdrop (from the event target when given one, else the topmost backdrop
// on the page), so nested modals close one layer at a time.
export function dismissModal(onClose, e) {
  let backdrop = null;
  try {
    const from = e?.currentTarget || e?.target;
    backdrop = from?.closest?.(".modal-backdrop") || null;
  } catch { /* detached target */ }
  if (!backdrop) {
    const all = document.querySelectorAll(".modal-backdrop:not(.modal-closing)");
    backdrop = all[all.length - 1] || null;
  }
  if (!backdrop) { onClose?.(); return; }
  if (backdrop.classList.contains("modal-closing")) return; // already on its way out
  backdrop.classList.add("modal-closing");
  let done = false;
  const finish = () => { if (!done) { done = true; onClose?.(); } };
  backdrop.addEventListener("animationend", finish, { once: true });
  setTimeout(finish, 280); // in case animations are disabled
}

// For conditionally mounted IonModals (isOpen={true}, unmounted by their
// onDidDismiss): close buttons call this instead of clearing state - Ionic
// plays its own leave animation and the dismiss event does the unmount.
export function closeIonModal(e, fallback) {
  let m = null;
  try { m = e?.target?.closest?.("ion-modal") || null; } catch { /* detached */ }
  if (!m) {
    const all = document.querySelectorAll("ion-modal");
    m = all[all.length - 1] || null;
  }
  if (m?.dismiss) m.dismiss().catch(() => { fallback?.(); });
  else fallback?.();
}
